import { ViewService } from '@xeetr/types/models'

import ApiService from './common/API.service'

export class ServiceService extends ApiService {
  getServices = async (): Promise<ViewService[]> => {
    const { data } = await this.get<ViewService[]>(this.buildCommonUrl('services'))
    return data
  }

  patchService = async (id: string, service: Partial<ViewService>): Promise<ViewService> => {
    const { data } = await this.patch<unknown, ViewService>(
      this.buildCommonUrl(`services/${id}`),
      service
    )
    return data
  }

  createService = async (service: ViewService): Promise<ViewService> => {
    const { data } = await this.post<ViewService, ViewService>(
      this.buildCommonUrl('services'),
      service
    )
    return data
  }

  deleteService = async (id: string): Promise<void> => {
    await this.delete(this.buildCommonUrl(`services/${id}`))
  }
}
